module.exports = __webpack_public_path__ + "static/media/icon_case_teeth.66d94e1f.svg";